import React, { useState } from "react";
import AllPending from "./AllPending";
import OutOfStock from "./OutOfStock";
import { Container } from "reactstrap";
import { Tabs } from "react-bootstrap";
import { Tab } from "bootstrap";
import processNextLogo from "../../assets/icon/process-next.svg";
import resubmitClaims from "../../assets/icon/resubmit-claims.svg";
import PrescriberCalls from "./PrescriberCalls";
import phoneIcon from "../../assets/icon/phone.svg";
import BackOrdered from "./BackOrdered";

const index = () => {
  const [active, setActive] = useState("tab-4");

  const handleClick = (e) => {
    setActive(e.target.id);
  };

  return (
    <Container fluid className="bin_info rounded p-3 pt-0 pb-0">
      <div className="btn-container">
        <div className="btncroll">
          <button
            className={`btn-tab ${active === "tab-1" ? "active" : ""}`}
            id="tab-1"
            onClick={handleClick}
          >
            <img src={processNextLogo} alt="" style={{ marginRight: "10px" }} />
            All Pending
          </button>
          <button
            id="tab-2"
            className={`btn-tab ${active === "tab-2" ? "active" : ""}`}
            onClick={handleClick}
          >
            {" "}
            <img src={resubmitClaims} alt="" style={{ marginRight: "10px" }} />
            Out of Stock
          </button>
          <button
            className={`btn-tab ${active === "tab-3" ? "active" : ""}`}
            id="tab-3"
            onClick={handleClick}
          >
            <img src={phoneIcon} alt="" style={{ marginRight: "10px" }} />
            Prescriber Calls
          </button>
          <button
            className={`btn-tab ${active === "tab-4" ? "active" : ""}`}
            id="tab-4"
            onClick={handleClick}
          >
            <img src={resubmitClaims} alt="" style={{ marginRight: "10px" }} />
            Backordered
          </button>
          <button
            className={`btn-tab ${active === "tab-5" ? "active" : ""}`}
            id="tab-5"
            onClick={handleClick}
          >
            <img src={undefined} alt="" style={{ marginRight: "10px" }} />
            Others
          </button>
        </div>
      </div>
      <div className="tab-content">
        <div className={`tab-page ${active === "tab-1" ? "active" : ""}`}>
          IN Development
        </div>
        <div className={`tab-page ${active === "tab-2" ? "active" : ""}`}>
          <OutOfStock />
        </div>
        <div className={`tab-page ${active === "tab-3" ? "active" : ""}`}>
          <PrescriberCalls />
        </div>
        <div className={`tab-page ${active === "tab-4" ? "active" : ""}`}>
          <BackOrdered />
        </div>
        <div className={`tab-page ${active === "tab-5" ? "active" : ""}`}>
          In Development
        </div>
      </div>
    </Container>
  );
};

export default index;
